const DetectMobile = (props) => {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    alert('我们检测到您正在使用手机访问本网站，目前本站尚未对手机做适配处理，请您优先使用电脑浏览，我们会尽快优化处理，同时推出手机端版本，感谢您的理解与支持。');
  }
  return <></>
}

export default DetectMobile;
